import script from "./loading.vue?vue&type=script&setup=true&lang=js"
export * from "./loading.vue?vue&type=script&setup=true&lang=js"

import "./loading.vue?vue&type=style&index=0&id=08d80ac5&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d80ac5"]])

export default __exports__